
















































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import gql from 'graphql-tag'
import BlkDeleteModal from '@/components/modals/BlkDeleteModal.vue'

interface fileType {
  description: string
  fileName: string
  s3Key: string
  public: boolean
}

interface controlType {
  disabled: boolean
}

@Component({
  name: 'BlkListFiles',
  components: { BlkDeleteModal }
})
export default class extends Vue {
  @Prop({ default: [] }) files!: Array<fileType>
  @Prop({ type: Boolean, default: false }) canDelete!: Boolean
  @Prop() isVerified!: Boolean
  @Prop({ type: Boolean, default: false }) small!: Boolean

  toastError = false
  fileNameError = ''
  btnControl: controlType[] = []
  modalItem = ''
  modalShowing = false
  deletedKey = ''
  deletedIndex = 0

  created() {
    this.onFilesChange()
  }

  @Watch('files', { deep: true })
  onFilesChange() {
    for (let i = 0; i < this.files.length; i++) {
      this.btnControl.push({ disabled: false })
    }
  }

  apollo = {
    downloadFileUrl: {
      query: gql`
        query($s3Key: String!) {
          downloadFileUrl(s3Key: $s3Key)
        }
      `,
      variables: {
        s3Key: ''
      }
    }
  }

  getFileIcon(fileName: string) {
    const file = fileName.toLowerCase()
    if (file.includes('.pdf')) {
      return ['far', 'file-pdf']
    } else if (
      file.includes('.jpg') ||
      file.includes('.jpeg') ||
      file.includes('.png') ||
      file.includes('.bmp')
    ) {
      return ['far', 'file-image']
    } else if (file.includes('.doc')) {
      return ['far', 'file-word']
    } else if (file.includes('.ppt')) {
      return ['far', 'file-powerpoint']
    } else if (file.includes('.xls')) {
      return ['far', 'file-excel']
    } else {
      return ['far', 'file']
    }
  }

  downloadLink(blob: string, filename: string) {
    const a = document.createElement('a')
    a.download = filename
    a.href = blob
    document.body.appendChild(a)
    a.click()
    a.remove()
  }

  downloadFile(key: string, name: string, index: number) {
    this.btnControl[index].disabled = true
    this.apollo.downloadFileUrl.variables.s3Key = key
    this.$apollo
      .query({
        query: this.apollo.downloadFileUrl.query,
        variables: this.apollo.downloadFileUrl.variables
      })
      .then(({ data }) => {
        this.toastError = false
        const fileUrl = data.downloadFileUrl
        this.createBlob(fileUrl, index, name)
      })
      .catch(() => {
        this.toastError = true
        this.btnControl[index].disabled = false
        const desc = this.$tc('files.downloadError')
        this.$bvToast.toast(desc, {
          title: this.$tc('users.alerts.error'),
          variant: 'danger',
          solid: true
        })
      })
  }

  createBlob(fileUrl: string, index: number, name: string) {
    fetch(fileUrl, {
      headers: new Headers({
        Origin: location.origin
      }),
      mode: 'cors'
    })
      .then((response) => {
        if (response.ok) return response.url
        else throw response.statusText
      })
      .then((url) => {
        this.toastError = false
        this.downloadLink(url, name)
        this.btnControl[index].disabled = false
      })
      .catch(() => {
        this.toastError = true
        this.btnControl[index].disabled = false
        const desc = this.$tc('files.downloadError')
        this.$bvToast.toast(desc, {
          title: this.$tc('users.alerts.error'),
          variant: 'danger',
          solid: true
        })
      })
  }

  openDeleteModal(key: string, item: string, index: number) {
    this.deletedKey = key
    this.modalItem = item
    this.deletedIndex = index
    if (!!this.modalItem) {
      this.modalShowing = true
      if (this.isVerified) {
        this.$bvModal.show('modal-delete-verified')
      } else {
        this.$bvModal.show('modal-delete')
      }
    }
  }

  updateShowing() {
    this.modalShowing = false
  }

  deleteFile(key: string, index: number) {
    this.modalShowing = false
    this.$apollo
      .mutate({
        mutation: gql`
          mutation($s3Key: String!) {
            deleteFile(s3Key: $s3Key) {
              result
            }
          }
        `,
        variables: {
          s3Key: this.deletedKey
        }
      })
      .then(() => {
        this.$emit('removeFile', index)
      })
  }
}
